/**
 *  --- STORE SCHEMA :
 *  {
 *      geometry { type , coordinates },
 *      properties { store_id , name , address , contact , open , weekly_opening }
 *  }
 *
 *  --- GEOLOC SCHEMA :
 *  { accuracy , latitude , longitude }
 */

const WOOSMAP_KEYS = {
  prod: {
    AU: 'woos-71a78956-e760-3e31-8a05-f0ba1d737637',
    BE: 'woos-9f8c8ff6-ebbf-34aa-ae1c-437fde9f85e7',
    CN: 'woos-bd4119f8-8bf7-3891-96d8-ae6a4df2cf0b',
    DE: 'woos-77d134ba-bbcc-308d-959e-9a8ce014dfec',
    ES: 'woos-5dbb4402-9d17-366b-af49-614910204d64',
    FR: 'woos-c7283e70-7b4b-3c7d-bbfe-e65958b8769b',
    GB: 'woos-4c9860ae-4147-39e0-af88-6d56fc1a5ab6',
    HK: 'woos-728dcea4-4a6f-322a-8a84-0bb40fe79c59',
    NL: 'woos-3019bc60-8e57-3c2a-8e6f-1893e1e44466',
    IT: 'woos-25d7be73-ee80-3e98-915d-a5349756f5d2',
    PL: 'woos-1a635f2d-aee1-3a1d-a21e-a8fe3ae1da21',
    CH: 'woos-7b40f2ea-b0a6-3a3b-9315-53ca807b601c',
    PT: 'woos-c224dd3f-84cf-336c-a5f8-ef7272389ae3',
    HU: 'woos-f4e1c407-8623-32f6-aaf9-c586e8ef2337',
    TR: 'woos-02fa0b82-a54d-3cc3-bdfa-3ce69249f220',
    RO: 'woos-a11e8e0e-80e2-35e1-8316-ca1d015a4ed0',
    CZ: 'woos-8e13088e-16a2-322a-9440-1681be0d34ef',
  },
  preprod: {
    AU: 'woos-419dffad-c63a-31f7-aa6b-7edeeacc0587',
    BE: 'woos-511db8ee-4775-34e1-a613-72c593d033be',
    CN: 'woos-2f816c21-9f8f-388c-b239-765f3672a727',
    DE: 'woos-e2210bee-88de-3123-806c-10a0d851b5cb',
    ES: 'woos-ec34e453-2fc6-395c-bbd5-3933675529a3',
    FR: 'woos-f46d35c7-3fcc-35e7-9a25-a54996899312',
    GB: 'woos-43a0fb3d-5c2c-39e0-a920-a3870cbe5102',
    HK: 'woos-db12ec3d-b878-3623-a82d-e4f9b9e2fc5b',
    NL: 'woos-e79b86fa-c3d2-38e1-831f-bdf44995dc6b',
    IT: 'woos-feaa4ef5-5745-361b-8f31-658c6552f0e1',
    PL: 'woos-8e618bd3-13a1-3422-86c0-153d23b63c61',
    CH: 'woos-b264c321-2e19-3097-a210-d5ce22bd883c',
    PT: 'woos-9d412e65-602b-35e4-b2c5-d17d04dd9335',
    HU: 'woos-144b5218-695a-31fc-aed7-7bf471871d24',
    TR: 'woos-0589a507-e4d2-3a98-871d-33d27673a435',
    RO: 'woos-6bad4984-032a-3759-8823-42214faf6a55',
    CZ: 'woos-005c3e75-1389-3489-97eb-3a56ce747a32',
  },
  integ: {
    AU: 'woos-419dffad-c63a-31f7-aa6b-7edeeacc0587', // iso Preprod
    BE: 'woos-8dcabf1c-872c-33a9-9869-60a5a714e193',
    CN: 'woos-2f816c21-9f8f-388c-b239-765f3672a727', // iso Preprod
    DE: 'woos-41a1fcbc-b95d-370d-9f7d-06cac3a96f62',
    ES: 'woos-723ae0e0-0237-3c4d-9d30-caf6788af960',
    FR: 'woos-3055801e-e006-36be-9d60-b3a2e336f8c0',
    GB: 'woos-d5e13816-c2c3-317f-a442-346d0a0f9cec',
    HK: 'woos-db12ec3d-b878-3623-a82d-e4f9b9e2fc5b', // iso Preprod
    NL: 'woos-19e6a408-c225-35f2-99f6-ada9c9ad84ec',
    IT: 'woos-4e1e81c1-770f-366d-95d6-02f44130fca7',
    PL: 'woos-8e618bd3-13a1-3422-86c0-153d23b63c61', // iso Preprod
    CH: 'woos-b264c321-2e19-3097-a210-d5ce22bd883c', // iso Preprod
    PT: 'woos-c7807066-bbe8-3658-997a-0f918b22a51a',
    HU: 'woos-144b5218-695a-31fc-aed7-7bf471871d24', // iso Preprod
    TR: 'woos-0589a507-e4d2-3a98-871d-33d27673a435', // iso Preprod
    RO: 'woos-6bad4984-032a-3759-8823-42214faf6a55', // iso Preprod
    CZ: 'woos-005c3e75-1389-3489-97eb-3a56ce747a32', // iso Preprod
  },
};

const WOOSMAP_ADVANCED_COUNTRIES = ['PL', 'HU', 'TR', 'RO', 'CZ'];

const GOOGLE_DATA = {
  BE: {
    key: '#Secret',
    channelID: 51,
  },
  DE: {
    key: '#Secret',
    channelID: 50,
  },
  ES: {
    key: '#Secret',
    channelID: 45,
  },
  FR: {
    key: '#Secret',
    channelID: 49,
  },
  GB: {
    key: '#Secret',
    channelID: 47,
  },
  HK: {
    key: '#Secret',
    channelID: 48,
  },
  NL: {
    key: '#Secret',
    channelID: 52,
  },
  IT: {
    key: '#Secret',
    channelID: 46,
  },
  PL: {
    key: '#Secret',
    channelID: 42,
  },
  CH: {
    key: '#Secret',
    channelID: 43,
  },
  PT: {
    kkey: '#Secret',
    channelID: 41,
  },
  HU: {
    key: '#Secret',
    channelID: 65,
  },
  TR: {
    key: '#Secret',
    channelID: 39,
  },
  RO: {
    key: '#Secret',
    channelID: 38,
  },
  CZ: {
    key: '#Secret',
    channelID: 37,
  },
};

// Handle variable URL for woosmap API
const ENV = window && window.tc_vars.env_work;
const COUNTRY = window && window.tc_vars.env_country;
const DOMAIN = COUNTRY === 'CN' ? 'cn' : 'com';
const WOOSMAP_KEY = WOOSMAP_KEYS[ENV] && WOOSMAP_KEYS[ENV][COUNTRY];
const IS_WOOSMAP_ADVANCED = WOOSMAP_ADVANCED_COUNTRIES.includes(COUNTRY);
const GOOGLE_KEY = GOOGLE_DATA[COUNTRY] && GOOGLE_DATA[COUNTRY].key;
const GOOGLE_CHANNEL_ID = GOOGLE_DATA[COUNTRY] && GOOGLE_DATA[COUNTRY].channelID;
const URL_WOOSMAP_SEARCH = `https://api.woosmap.${DOMAIN}/stores/search/?key=${WOOSMAP_KEY}`;

module.exports = {
  WOOSMAP_KEY,
  IS_WOOSMAP_ADVANCED,
  GOOGLE_KEY,
  GOOGLE_CHANNEL_ID,
};

// STATE
let GEOLOC = {};

/**
 * Generic method that call the Woosmap STORES API
 * @param {Object} params { query , lat , lng , radius , page , stores_by_page }
 * @param {Function} callback
 */
module.exports.getStores = function getStores(params, callback) {
  // build URL query string paramters
  const strParams = Object.keys(params)
    .map(k => `${k}=${encodeURIComponent(params[k])}`)
    .join('&');
  // call Woosmap API and returns stores through CALLBACK
  cube.ajax
    .get(`${URL_WOOSMAP_SEARCH}&${strParams}`)
    .onSuccess(data => {
      if (data.features && data.features.length > 0 && callback) callback(data.features);
      else if (callback) callback([]);
    })
    .onError(data => {
      console.error(data);
    })
    .call();
};

/**
 * Use the HTML5 geolocation API
 * returns the user geoloc throught CALLBACK
 * @param {Function} callback
 */
let isGeolocSearching = false;
module.exports.askLocation = function askLocation(callback) {
  // if GEOLOC is already defined : return it
  if (Object.keys(GEOLOC).length > 1) callback(GEOLOC);
  else if (navigator.geolocation && !isGeolocSearching) {
    // if GEOLOC is available : ask to the user and search it
    isGeolocSearching = true;
    navigator.geolocation.getCurrentPosition(geopoint => {
      isGeolocSearching = false;
      // set user's GEOLOC globally
      GEOLOC = {
        accuracy: geopoint.coords.accuracy,
        latitude: geopoint.coords.latitude,
        longitude: geopoint.coords.longitude,
      };
      callback(GEOLOC);
    });
  }
};

/**
 * Get the (${limit} || 10) first nearest stores around the GEOLOC
 * @param {Object} params
 * @param {Function} callback
 */
module.exports.getNearestStores = function getNearestStores(limit, callback) {
  // effectively search nearest stores from GEOLOC params
  const searchNearestStore = function searchNearestStore(_geoloc) {
    // configure & call API
    module.exports.getStores(
      {
        lat: _geoloc.latitude,
        lng: _geoloc.longitude,
        stores_by_page: limit || 10,
      },
      callback
    );
  };
  // we already have GEOLOC : search nearest store
  if (Object.keys(GEOLOC).length > 1) searchNearestStore(GEOLOC);
  // we don't have GEOLOC : ask for it and search after
  else module.exports.askLocation(searchNearestStore);
};

/**
 * Get and returns the nearest store around the user
 * - ask location to the user if we don't have it yet
 * @param {Function} callback
 */
module.exports.getNearestStore = function getNearestStore(callback) {
  // get the first nearest store
  module.exports.getNearestStores(1, stores => {
    callback(stores[0]);
  });
};

/**
 * Search for a list of stores, based on store parameters
 * @param {Object} params { idstore , name }
 * @param {Function} callback
 */
const searchStoresParams = ['idstore', 'name'];
module.exports.searchStores = function searchStores(params, callback) {
  // filter out params and build query
  const strQuery = Object.keys(params)
    .filter(k => searchStoresParams.indexOf(k) > -1)
    .map(k => `${k}:"${params[k]}"`)
    .join(' AND ');
  // call API
  module.exports.getStores({ query: strQuery }, callback);
};

module.exports.setDefaultStore = function setDefaultStore(storeId) {
  return new Promise((resolve, reject) => {
    const storeSettingUrl = 'rest/model/atg/userprofiling/ProfileActor/setNavigationLocationId';
    cube.ajax
      .post(storeSettingUrl, { navigationLocationId: storeId })
      .onSuccess(() => {
        resolve();
        cube.cartridge('header-store').reload();
      })
      .onError(reject)
      .call();
  });
};

module.exports.getDefaultStore = callbackFunction => {
  const URL_GET_NAVIGATION_LOCATION_ID = 'rest/model/atg/userprofiling/ProfileActor/getNavigationLocationId';
  cube.ajax
    .get(URL_GET_NAVIGATION_LOCATION_ID)
    .onSuccess(res => {
      if (res && res.responseTO && res.responseTO.data) callbackFunction(res.responseTO.data);
      else callbackFunction(null);
    })
    .onError(err => {
      callbackFunction(null);
    })
    .call();
};

// cube.stores.getDefaultStore(storeId => {
//   if (storeId) return storeId;
//   console.log('No Favorite Store');
// });

module.exports.getCountryStoresList = function getCountryStoresList(callback) {
  //
  const divID = 'div-country-stores-list';
  const divTPath = 'sl_storelist';
  const divTUrl = 'content/Web/Store Locator Pages/Default NL Store Locator';

  // If DIV if not present : create it & append it to BODY
  if (!cube.$id(divID)) {
    const div = document.createElement('div');
    div.id = divID;
    div.dataset.tPath = divTPath;
    div.dataset.tUrl = divTUrl;
    div.style.display = 'none';
    document.body.appendChild(div);
  }

  // Reload DIV
  cube
    .cartridge(divID)
    .after(() => {
      // DIV is reloaded : return the EVAL'ed value of the SCRIPT tag
      // eslint-disable-next-line no-eval
      const list = eval(cube.$id('script-country-stores-list').innerHTML);
      if (typeof callback === 'function') {
        // Flatten the list (remove 'letter' level)
        const flatList = list.reduce((acc, e) => acc.push(...e.stores) && acc, []);
        callback(flatList);
      }
    })
    .reload();
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-stores.js